module.exports = __webpack_public_path__ + "static/inside_out-7d715e500fb03f36b1da47deda2a0684.png";